import { getWidgetType } from './widgetTypes';

function isObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function toPositiveInt(value, fallback) {
  var next = Number(value);
  if (!Number.isFinite(next) || next < 1) {
    return fallback;
  }
  return Math.floor(next);
}

export function normalizeWidget(widget, index) {
  var safeWidget = isObject(widget) ? widget : {};
  var data = isObject(safeWidget.data) ? safeWidget.data : {};

  return {
    ...safeWidget,
    id: safeWidget.id || 'widget-' + index,
    type: safeWidget.type || getWidgetType(safeWidget),
    xCoordinate: toPositiveInt(safeWidget.xCoordinate, 1),
    yCoordinate: toPositiveInt(safeWidget.yCoordinate, 1),
    width: toPositiveInt(safeWidget.width, 1),
    height: toPositiveInt(safeWidget.height, 1),
    data,
    parameters: isObject(safeWidget.parameters) ? safeWidget.parameters : {},
    parameterJson: isObject(safeWidget.parameterJson) ? safeWidget.parameterJson : {},
    headerLabel: safeWidget.headerLabel || data.headerLabel || '',
    subHeaderLabel: safeWidget.subHeaderLabel || data.subHeaderLabel || '',
    icon: safeWidget.icon || data.icon || ''
  };
}

export function normalizeReportPage(pageJson) {
  var source = isObject(pageJson) ? pageJson : {};
  var widgets = Array.isArray(source.widgets) ? source.widgets : [];

  return {
    ...source,
    id: source.id || 'untitled-report',
    name: source.name || 'Untitled Report',
    widgets: widgets.map(normalizeWidget)
  };
}

export function validateReportPage(pageJson) {
  var errors = [];

  if (!isObject(pageJson)) {
    errors.push('Report page must be an object.');
  }

  if (!Array.isArray((pageJson || {}).widgets)) {
    errors.push('Report page must include a widgets array.');
  }

  var normalized = normalizeReportPage(pageJson);
  return {
    valid: errors.length === 0,
    errors,
    page: normalized
  };
}
